<template>
    <!-- 军事/公安类升学(民航招飞，海军招飞，空军招飞，军校招生，公安院校，航海类院校) -->
    <!-- 空军招飞 -->
    <div class="air_force studyway_common_father">
        <div class="banner">
            <img src="/imgs/wayToStudy/main/banner_tool.png" alt="">
        </div>
        <div class="main">
            <h6 class="main_title">关于空军飞行员</h6>
            <div class="main_box">
                <p>空军飞行人员是国家的特殊人才和宝贵资源，其招收培养属国家行为。招收飞行学员（简称招飞）工作，在国家教育部、公安部、财政部和军委政治工作部领导下，由空军会同有关省（自治区、直辖市）的教育、公安部门组织实施，纳入全国普通高校招生体系，是军队院校招生工作的重要组成部分。空军设立招飞局，辖沈阳、北京、兰州、济南、南京、广州、成都7个招飞中心。1987年空军自主招飞以来，承担了空军和陆航部队全部招飞任务，除为国家培养选拔航天员外，还为海军航空兵输送了大批飞行骨干人才，累计招收飞行学员3.6万余名，较好地满足了国防建设飞行人才补充需要。</p>
            </div>    
        </div>
        <div class="application_condition main">
            <h6 class="main_title">报考条件有哪些？</h6>
            <div class="main_box">
                <p><span>身体条件</span>：身高在164-185cm之间，体重不低于标准体重的80%、不高于标准体重的130%，标准体重（kg）=身高（cm）-110。裸眼视力C字表0.8以上，未做过视力矫治手术，无色盲、色弱、斜视等。</p>
                <p><span>政治条件</span>：考生热爱祖国，热爱人民，热爱中国共产党，热爱人民军队。符合招飞政治考核标准条件，本人自愿，家长（监护人）支持。</p>
                <p><span>心理品质条件</span>：对飞行有较强的兴趣和愿望，思维敏捷、反应灵活、动作协调、学习能力强，具备一定的领导决策能力和团队协作意识，性格开朗、情绪稳定，有敢为精神。</p>
                <p><span>文化条件</span>：普通中学高中毕业生报名参加招飞,需品学兼优，高考成绩达到本省统招生一本线。</p>
            </div>
        </div>
        <div class="main">
            <h6 class="main_title">招收对象是谁？</h6>
            <div class="main_box">
                <p>空军面向两类学生招收选拔飞行学员：</p>
                <p>（1）普通高中应届、往届毕业生，男性，年龄不小于17周岁、不超过20周岁。</p>
                <p>（2）军队院校应届本科毕业生，男性，年龄不超过24周岁。</p>
            </div>
        </div>
        <div class="main">
            <h6 class="main_title">培养模式</h6>
            <div class="main_box">
                <p>高中生飞行学员入空军航空大学后，实行3个月考察期，合格者取得学籍、军籍。具体采取两种培养模式：“四年一贯制”培养模式和“3+1”军地联合培养模式。</p>
                <p class="title">“四年一贯制”</p>
                <p class="detail">飞行学员在空军航空大学全程培养4年，主要进行基础教育和初级教练机飞行训练。</p>
                <p class="title">“3+1”军地联合</p>
                <p class="detail">飞行学员在北京大学、清华大学、北京航空航天大学学习3年，在空军航空大学学习1年。</p>
            </div>
        </div>
        <div class="main application_process">
            <h6 class="main_title">报考流程（以简章为主）</h6>
            <ul class="lis_box">
                <li>
                    <p>报名</p>
                    <p>9月-10月</p>
                </li>
                <li>
                    <p>初选</p>
                    <p>10月-11月</p>
                </li>
                <li>
                    <p>复选</p>
                    <p>12月-次年5月</p>
                </li>
                <li>
                    <p>定选</p>
                    <p>6月-7月</p>
                </li>
            </ul>
        </div>
        <div class="main">
            <h6 class="main_title">培养模式</h6>
            <div class="main_box">
                <p>飞行人员是党和国家的宝贵财富，享有较高的政治待遇和社会荣誉。由于飞行工作的特殊需要，飞行人员除享受现役军宫的待遇外，还按照有关规定享受飞行人员特有的待遇。</p>
                <p>飞行学员取得学籍后，从开学之日起计算军龄，家庭享受军属待遇，学习期间一切费用由国家提供，同地方院校和部分军队院校相比，家庭可节省经费6-7万;飞行学员在校学习期间的第二学年安排探亲假;飞行学员毕业后任飞行军官，授予空军中尉军衔，享受优厚的工资待遇，不需要考虑就业问题，解决了后顾之忧;根据个人飞行技能，享受飞行等级补助金和飞行小时补助金;飞行人员的行政职务，根据飞行年限一般均可由连职逐级晋升至师职。</p>
                <p>为了保证飞行人员有强健的体魄，国家规定飞行人员有较高的伙食标准，学员在校学习期间享受学员津贴，毕业后按任命的职务、级别、军衔发给相应的工资;每年可享受身体健康疗养一个月;飞行人员结婚后，配偶即可随军，随军后优先安排住房和工作，没有随军的每年安排探亲休假一次;单身的飞行员住飞行员公寓，房间设备齐全;飞行人员的子女参加地方高考、中考，凡符合空军院校招生条件的，优先录入空军院校学习。</p>
            </div>   
        </div>
        <div class="universities">
            <table>
                <tr>
                    <th>单 位</th>
                    <th>联系电话</th>
                    <th>地址</th>
                    <th>邮编</th>
                    <th class="area">负责区域</th>
                </tr>
                <tr v-for="(item,index) in universities" :key="index">
                    <td>{{item.company}}</td>
                    <td><p  v-html="item.tel"></p></td>
                    <td>{{item.address}}</td>
                    <td><p>{{item.postcode}}</p></td>
                    <td>{{item.area}}</td>
                </tr>
            </table>
            <p class="air_tr">
                <span>空军招飞网</span>
                <span>http://www.kjzfw.net</span>
            </p>
            <p class="air_ft">★空军招收飞行学员政策规定，由空军招飞局负责解释。未尽事宜，请来电来函，或登录空军招飞网查询</p>
         </div>
    </div>
</template>
<script>
export default {
    // components: { Yuanxiaoku },
    // props: [ 'message' ],
     data() {
        return {
            universities: [ 
                { company: '空军招飞局', tel: '010—66921803<br/>010—66983994', address: '北京市海淀区闵航路25号', postcode: '100195', area: '' },
                { company: '沈阳选拔中心', tel: '024—24280378', address: '辽宁省沈阳市沈河区万柳塘路51号', postcode: '110015', area: '辽宁、吉林、黑龙江'  },
                { company: '北京选拔中心', tel: '010—66911710', address: '北京市东城区光明路甲1号', postcode: '100061', area: '北京、天津、河北山西、内蒙古'  },
                { company: '兰州选拔中心', tel: '0931—4865353', address: '甘肃省兰州市城关区东岗东路913号', postcode: '730020', area: '甘肃、陕西、青海宁夏、新疆'  },
                { company: '济南选拔中心', tel: '0531—51697488', address: '山东省济南市英雄山路105号', postcode: '250002', area: '山东、河南'  },
                { company: '南京选拔中心', tel: '020—38809202', address: '江苏省南京市珠江路东大影壁16号', postcode: '210018', area: '上海、江苏、浙江安徽、江西、福建'  },
                { company: '广州选拔中心', tel: '020—38809202', address: '广东省广州市天河东路151号', postcode: '510620', area: '湖北、湖南、广东广西、海南'  },
                { company: '成都选拔中心', tel: '028—85399171', address: '四川省成都市九眼桥共和路2号', postcode: '610061', area: '    重庆、四川、云南、贵州'  }
            ]
        }
    },
    methods: {
        goUniversity(id) {
            var id = id;
            let {href}=this.$router.resolve({
                path: '/explore/yuanxiaoxiangqing',
                name: 'yuanxiaoxiangqing',
                query: {
                    id: id,
                }
            })
            // window.open(href, '_blank');
             this.$router.push('/explore/yuanxiaoxiangqing?id='+id)
        }
    },
    created() {
    }
}
</script>
<style type="text/css" lang='less' scoped>
    @import "../study_way_common.less";
    .air_force {
        .universities {
            table {
                border: 1px solid #eaeaea;
                font-size: 14px;
                text-align: center;
                tr {
                    th {
                        box-sizing: border-box;
                        line-height: 50px;
                        text-align: center;
                        border: 1px solid #60badf;
                        background-color: #60badf;
                        color: #fff;
                        &:nth-child(1) {
                            width: 15%; 
                        }
                        &:nth-child(2) {
                            width: 15%; 
                        }
                        &:nth-child(3) {
                            width: 30%; 
                        }
                        &:nth-child(4) {
                            width: 10%; 
                        }
                        &:nth-child(5) {
                            width: 30%; 
                        }
                    }
                }
                tr {
                    &:nth-child(odd) {
                        background-color: #e6f8ff;
                    }
                    td {
                        border: 1px solid #eaeaea;
                        line-height: 40px;
                        align-items: center;
                        &:first-child {
                            cursor: pointer;
                        }
                        p {
                            line-height: 24px;
                        }
                    }
                }
                .air_tr {
                    td {
                        &:nth-child(1) {
                            float: left;
                            width: 143px;
                        }
                        &:nth-child(2) {
                            float: left;
                            width: 200px;
                        }
                    }
                }
            }
            .air_tr {
                display: flex;
                line-height: 40px;
                border: 1px solid #eaeaea;
                border-top: none;
                span {
                    text-align: center;
                    &:nth-child(1) {
                        width: 15%;
                        border-right: 1px solid #eaeaea;
                    }
                    &:nth-child(2) {
                        width: 85%;
                    }
                }
            }
            .air_ft {
                line-height: 40px;
                border: 1px solid #eaeaea;
                text-align: center;
                border-top: none;
                color: #2c8ffc;
            }
        }
    }
</style>